import styled from 'styled-components';

export const HomeStaySpacesWrapper = styled.div(
  props => `
    max-width: 120rem;
    margin: 0 auto;
    padding: 3.2rem 0 4rem;
  `,
);

export const HomeStaySpacesInnerWrapper = styled.div(
  props => `
    background: ${props.theme.colors.goWhite.base};
    border-radius: 12px;
    padding: 1.2rem;
    `,
);

export const ModalOuterWrapper = styled.div(
  props => `
      display: flex;
      width: 100%;
      height: 100%;
    `,
);

export const ModalLeftWrapper = styled.div(
  props => `
      padding: 1.2rem 2.4rem 2.4rem;
      background: #000000;
      width: 77.4rem;
      overflow: scroll;

      .masonryLayoutWrapper {
        gap: 2rem;
        columns: 2;
        display: flex;
        img {
          width: 100%;
          margin-bottom: 1.6rem;
        } 
      }

      .galleryHeader {
              font-style: normal;
        font-weight: 600;
        font-size: 18px;
        color: #FFFFFF;
        margin-bottom: 1.2rem;
      }
      .gallery1 {
        // height: 900px;
        background: blue;
        padding-top: 1.2rem;
      }

      .galleryWrapper {
        padding-top: 1.2rem;
      }
    `,
);

export const ModalRightWrapper = styled.div(
  props => `
      background: ${props.theme.colors.goWhite.base};
      flex:1;
    `,
);

export const ModalRightHeaderWrapper = styled.div(
  props => `
      padding: 1.6rem;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.146853);
      display: flex;
      justify-content:space-between;
      .headerText {
              font-style: normal;
        font-weight: 600;
        font-size: 18px;
        color: #141823;
      }
    `,
);

export const ModalRightContentWrapper = styled.div(props => `padding: 1.6rem;`);

export const ModalRightContentList = styled.ul(
  props => `
      max-height: 50rem;
      overflow-y:scroll;
    `,
);

export const ModalRightContentListItem = styled.li(
  props => `
      cursor: pointer;
      background: #FFFFFF;
      border: 2px solid ${props.selected ? '#2274E0' : '#E1E7EE'};
      border-radius: 12px;
      margin-bottom: 1.2rem;
      padding: 1.6rem 1.2rem;
      .headerText {
              font-style: normal;
        font-weight: 600;
        font-size: 14px;
        color: #000000;
        margin-bottom: 0.4rem;
        display: flex;
        align-items:center;
      }

      .commonTag {
        background: #E1F6F6;
        border-radius: 19px;
        padding: 2px 8px;
        color: #647A97;
        font-weight: 600;
        font-size: 12px;
        margin-left: 0.8rem;
      }

      .descText {
        font-weight: 400;
        font-size: 12px;
        color: #000000;
        mix-blend-mode: normal;
        opacity: 0.5;
      }

      .commonText {
        font-size: 12px;
        color: #647A97;
        display: flex;
        align-items:flex-start;
        margin-top: 0.8rem;
      }
    `,
);

export const HomeStayGalleryAllMediaImagesWrapper = styled.div(
  props => `
    position: relative;
  `,
);

export const WideImageModalWrapper = styled.div(
  props => `
    position: absolute;
    top: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
`,
);
